import * as React from 'react';

import { Translate } from 'src/containers/i18n';

const TemplateOutdatedPage: React.FC = () => {
  return <Translate id="template.outdatedNote" />;
};

export default TemplateOutdatedPage;
